import { HttpLink } from '@apollo/client';
import { GRAPH_URL } from '../constants/common';

export const httpLink = new HttpLink({ uri: GRAPH_URL });